import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { WebSocketProvider } from './context/WebSocketContext';
import Dashboard from './pages/Dashboard';
import Escalations from './pages/Escalations';
import Settings from './pages/Settings';
import ChatHistory from './pages/ChatHistory';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Agents from './pages/Agents';
import AddAgents from './pages/AddAgents';
import ChatPage from './pages/ChatPage';
import "antd/dist/reset.css";
import ConversationHistory from './components/Excalations/ConversationHistory';

function App() {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="flex justify-center items-center h-screen"></div>;
  }

  return (
    <AppProvider>
      <Router>
        <Routes>
          {/* Public routes - accessible without authentication - MUST be first */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* Chat page - no WebSocket needed */}
          <Route path="/chat" element={<ChatPage />} />
          
          {/* Protected routes - require authentication and WebSocket */}
          {token ? (
            <Route path="/" element={
              <WebSocketProvider>
                <MainLayout />
              </WebSocketProvider>
            }>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="escalations" element={<Escalations />} />
              <Route path="chat-history" element={<ChatHistory />} />
              <Route path="agents" element={<Agents />} />
              <Route path="add-agent/:id?" element={<AddAgents />} />
              <Route path="edit-agent/:id?" element={<AddAgents />} />
              <Route path="settings" element={<Settings />} />
              <Route path="conversation/:chatId" element={<ConversationHistory />} />
            </Route>
          ) : null}
          
          {/* Catch-all route - redirect to login for unmatched routes (only if not already matched above) */}
          <Route path="*" element={<Login />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
